import { render } from "./prihlasovani.vue?vue&type=template&id=948ba73a"
import script from "./prihlasovani.vue?vue&type=script&lang=js"
export * from "./prihlasovani.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__